import { isValidElement, ReactElement, ReactNode } from 'react';

type MenuChildProps = {
  data?: unknown;
  isSelected?: boolean;
};

/**
 * react-select hands the menu either its option elements or a single placeholder element for the
 * empty and loading states. Only options carry the `data` prop, which is what lets us tell a menu
 * holding one match apart from a menu holding no matches at all.
 */
export function isOptionElement(child: ReactNode): child is ReactElement<MenuChildProps> {
  return isValidElement<MenuChildProps>(child) && child.props.data !== undefined;
}

export function countOptionElements(children: ReactNode[]): number {
  return children.filter(isOptionElement).length;
}

export function findSelectedOptionIndex(children: ReactNode[]): number {
  const selectedIndex = children.findIndex((child) => isOptionElement(child) && child.props.isSelected === true);

  return selectedIndex === -1 ? 0 : selectedIndex;
}
